import { imageTypes } from "./enums";
import { ListOfFiles } from "./localStorageManagement";

/* LPPLWEBMOB-454 */
export class ImageProperties {
  static ifPdf = false;
  ifFromSingleUploader = true;
  static listLength = 1;
  static listIndex = 1;
  static ifSingleListEnds = false;
  static imageType: imageTypes = imageTypes.multi;
  private fileslist = ListOfFiles.GetListOfFiles();

  CurrentImagePropertiesCheck() {
    if (ImageProperties.imageType == imageTypes.front) {
      ImageProperties.ifPdf = ListOfFiles.frontImage.ifFileIsPdf;
    } else if (ImageProperties.imageType == imageTypes.back) {
      ImageProperties.ifPdf = ListOfFiles.backImage.ifFileIsPdf;
    } else {
      if (ListOfFiles.multiFiles.length != 0)
        ImageProperties.ifPdf =
          ListOfFiles.multiFiles[ImageProperties.listIndex].ifFileIsPdf;
      ImageProperties.listLength = ListOfFiles.multiFiles.length;
    }
  }
  incrementIndex() {
    if (ImageProperties.imageType == imageTypes.multi) {
      ImageProperties.listIndex += 1;
      if (ImageProperties.listIndex > ImageProperties.listLength - 1)
        ImageProperties.listIndex = 0;
    }
  }
}
/* LPPLWEBMOB-454 END */
